@if (showMiniGame) {
	<app-match-three
		(closed)="closedMiniGame()"
	/>
} @else if (!showResult && showGame) {
	<app-survey
		[personalityTypes]="personalityTypes"
		[questions]="questions"
		(selectedAnswer)="changeResult($event)"
	/>
} @else if (showResult && showGame) {
	<app-result
		[color]="color"
		[resultImg]="resultImg"
		[resultData]="resultData"
		[title]="title"
		(close)="closedModal()"
	/>
}